export const SET_EMOTE_POPPER_REFERENCE_SELECTOR = 'SET_EMOTE_POPPER_REFERENCE_SELECTOR'
export const SET_SELECTED_EMOTE = 'SET_SELECTED_EMOTE'
export const SET_DEFAULT_EMOTES = 'SET_DEFAULT_EMOTES'
export const SET_BTTV_EMOTES = 'SET_BTTV_EMOTES'
export const SET_BTTV_CHANNEL_EMOTES = 'SET_BTTV_CHANNEL_EMOTES'
